<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <RecordRemovalModal
          v-if="removalModalIsVisible"
          :removal-callback="removalCallback"
          @close="removalModalIsVisible = false"
        />
        <Preloader v-if="showPreloader" />
        <div v-else class="col-lg-12">
          <div class="prev-page-button__wrapper">
            <PreviousPageButton
              :disabled="disabled"
              :location-fallback-link="fallbackLink"
            />
          </div>
          <div class="form__panel_top">
            <div class="panel__subtitle">
              <h2 class="subtitle__text">{{ subtitle }}</h2>
              <div class="subtitle__buttons">
                <button
                  v-if="['add', 'edit'].includes(actionType)"
                  type="button"
                  class="btn btn-default btn-success"
                  :disabled="disabled"
                  @click="$emit('on-submit')"
                >
                  <i class="fa fa-check-circle-o" />
                  Сохранить изменения
                </button>
                <button
                  v-if="actionType === 'edit'"
                  type="button"
                  class="btn btn-default btn-danger"
                  :disabled="disabled"
                  @click="$emit('on-cancel')"
                >
                  <i class="fa fa-close" />
                  Отменить
                </button>
                <button
                  v-if="removalButtonIsVisible"
                  type="button"
                  class="btn btn-default btn-danger"
                  :disabled="disabled"
                  @click="removalModalIsVisible = true"
                >
                  <i class="fa fa-trash" />
                  Удалить
                </button>
              </div>
              <div
                v-if="actionType === 'read' && checkVipRole()"
                class="subtitle__button_edit"
              >
                <button
                  type="button"
                  class="btn btn-default btn-primary"
                  :disabled="disabled"
                  @click="$emit('on-edit')"
                >
                  <i class="fa fa-edit" />
                  Редактировать
                </button>
              </div>
              <div class="panel_top">
                <slot name="top-panel-buttons"></slot>
              </div>
            </div>
            <div v-if="false" class="top-part__balance">
              <span>Остаток на складе: {{ stockBalance }}</span>
              <div class="top-part__buttons">
                <button
                  class="btn btn-primary balance__button_update"
                  type="button"
                  :disabled="disabled"
                  @click="updateStockBalance"
                >
                  <i class="fa fa-rotate-right" />
                  Обновить
                </button>
              </div>
            </div>
          </div>
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="row">
                <form
                  role="form"
                  @submit.prevent="$emit('on-submit')"
                  ref="form"
                >
                  <div class="row">
                    <Dates
                      v-if="formBody.created_at"
                      :update-date="formBody.updated_at"
                      :create-date="formBody.created_at"
                    />
                  </div>
                  <slot name="fields"></slot>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreviousPageButton from "@/_shared/components/ui/PreviousPageButton";
import RecordRemovalModal from "@/_shared/components/modals/RecordRemovalModal";
import Preloader from "@/_shared/components/ui/Preloader";
import Dates from "@/_shared/features/form/Dates";
import { useRoleIdentifier } from "@/_shared/mixins";
import { stockComponentService } from "@/stock/api-services";
export default {
  mixins: [useRoleIdentifier],
  emits: ["on-submit", "on-edit", "on-cancel"],
  components: {
    PreviousPageButton,
    RecordRemovalModal,
    Preloader,
    Dates,
  },
  props: {
    formBody: {
      type: Object,
      default() {
        return {
          created_at: null,
          updated_at: null,
        };
      },
    },
    removalCallback: {
      type: Function,
      default: null,
    },
    fallbackLink: {
      type: String,
      default: "/cloths",
    },
    showPreloader: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    subtitle: {
      type: String,
      default: "Форма",
    },
    actionType: {
      type: String,
      default: "read",
      validator(value) {
        const allowedValues = ["read", "edit", "add"];
        return allowedValues.includes(value);
      },
    },
    startingStockBalance: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      removalModalIsVisible: false,
      stockBalance: 0,
    };
  },
  computed: {
    removalButtonIsVisible() {
      const isVip = this.checkVipRole();
      const hasRemovalFunction = typeof this.removalCallback === 'function';
      return this.actionType !== 'add' && isVip && hasRemovalFunction;
    },
  },
  methods: {
    async updateStockBalance() {
      const tableName = this.fallbackLink.substring(1);
      const { id } = this.formBody;
      const result = await stockComponentService.getBalance(tableName, id);
      this.stockBalance = result;
    },
  },
};
</script>

<style scoped>
.prev-page-button__wrapper {
  margin: 2em 0;
}
.panel_top,
.subtitle__buttons,
.subtitle__button_edit {
  margin-left: 1em;
}
.subtitle__buttons {
  display: inline-flex;
  flex-direction: row;
}

.subtitle__text {
  display: inline-block;
  margin: 0;
  padding: 0;
}

.panel__subtitle {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}

.form__panel_top {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 2em;
}

.subtitle__buttons > button:not(:last-child) {
  margin-right: 1em;
}

.top-part__balance {
  font-weight: 700;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.balance__button_update {
  margin-left: 1em;
}

@media (max-width: 1279px) {
  .panel__subtitle {
    row-gap: 1em;
    flex-direction: column;
  }
  .subtitle__text {
    text-align: center;
  }
  .panel__subtitle {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 1279px) {
  .panel_top,
  .subtitle__buttons,
  .subtitle__button_edit {
    margin-left: 0;
  }
  .form__panel_top {
    flex-direction: column-reverse;
  }
  .top-part__balance {
    margin-bottom: 2em;
  }
}

@media (max-width: 767px) {
  .top-part__balance {
    flex-direction: column;
  }
  .balance__button_update {
    margin-left: 0;
  }
  .top-part__buttons {
    margin-top: 1em;
  }
  .form-panel__subtitle {
    flex-direction: column;
  }
  .form-panel__subtitle > * {
    width: 100%;
  }
  .subtitle__buttons,
  .form-panel__subtitle {
    flex-direction: column;
  }
  .form-panel__subtitle > * {
    width: 100%;
  }
  .subtitle__buttons,
  .subtitle__button_edit {
    width: 100%;
    max-width: 200px;
    padding: 0;
  }
  .subtitle__button_edit > .btn {
    width: inherit;
  }
  .subtitle__buttons > button:not(:last-child) {
    margin-right: 0;
    margin-bottom: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/widgets/Form.vue